import createIcon from '../../createIcon';

/**
 * @component @name SubtitlesOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNDggMy4yOTUxMkg3LjMxMDAyTDE1LjMxIDExLjI5NTFIMjAuNDhWMTMuMjk1MUgxNy4zMUwyMi4yNCAxOC4yMjUxQzIyLjM5IDE3Ljk0NTEgMjIuNDggMTcuNjM1MSAyMi40OCAxNy4yOTUxVjUuMjk1MTJDMjIuNDggNC4xOTUxMiAyMS41OCAzLjI5NTEyIDIwLjQ4IDMuMjk1MTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMS41MjAwMiAzLjE2NTEyTDIuNzIwMDIgNC4zNjUxMkMyLjU3MDAyIDQuNjQ1MTIgMi40ODAwMiA0Ljk1NTEyIDIuNDgwMDIgNS4yOTUxMlYxNy4yOTUxQzIuNDgwMDIgMTguMzk1MSAzLjM4MDAyIDE5LjI5NTEgNC40ODAwMiAxOS4yOTUxSDE3LjY1TDIwLjYxIDIyLjI1NTFMMjIuMDIgMjAuODQ1MUwyLjkzMDAyIDEuNzQ1MTJMMS41MjAwMiAzLjE2NTEyWk04LjQ4MDAyIDExLjI5NTFWMTMuMjk1MUg0LjQ4MDAyVjExLjI5NTFIOC40ODAwMlpNMTQuNDggMTYuMTI1MVYxNy4yOTUxSDQuNDgwMDJWMTUuMjk1MUgxMy42NUwxNC40OCAxNi4xMjUxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SubtitlesOff = createIcon('SubtitlesOff', [
  [
    'path',
    {
      d: 'M20.48 3.29512H7.31002L15.31 11.2951H20.48V13.2951H17.31L22.24 18.2251C22.39 17.9451 22.48 17.6351 22.48 17.2951V5.29512C22.48 4.19512 21.58 3.29512 20.48 3.29512Z',
      key: 'drkmya',
    },
  ],
  [
    'path',
    {
      d: 'M1.52002 3.16512L2.72002 4.36512C2.57002 4.64512 2.48002 4.95512 2.48002 5.29512V17.2951C2.48002 18.3951 3.38002 19.2951 4.48002 19.2951H17.65L20.61 22.2551L22.02 20.8451L2.93002 1.74512L1.52002 3.16512ZM8.48002 11.2951V13.2951H4.48002V11.2951H8.48002ZM14.48 16.1251V17.2951H4.48002V15.2951H13.65L14.48 16.1251Z',
      key: 'n2jsgy',
    },
  ],
]);

export default SubtitlesOff;
